


























import {
    defineComponent,
    reactive,
    watch,
    onMounted,
    PropType,
} from '@vue/composition-api';
import { getFeedImageSize } from '@/common/util';

import { DynamicImage } from '../../type';
import defaultErrImage from '@/assets/images/errorFeedImage.png';

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<DynamicImage>,
            default: () => ({}),
        },
        imageType: {
            type: String as PropType<'urlDefault' | 'urlPreview'>,
            default: 'urlDefault',
        },
        isSmall: {
            type: Boolean,
            default: true,
        },
        imgStyle: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const state = reactive({
            parseExtraInfo: {} as any,
            error: false,
        });

        const { item, imageType, isSmall } = props;
        const { normalImgInfo, textImgInfo } = item || {};
        const { width = 0, height = 0 } = normalImgInfo || {};
        const { desc, extraInfo } = textImgInfo || {};
        const imageObj = getFeedImageSize(width, height);

        watch(
            () => textImgInfo,
            () => {
                try {
                    if (typeof extraInfo === 'string') {
                        state.parseExtraInfo = JSON.parse(extraInfo);
                    } else {
                        state.parseExtraInfo = extraInfo;
                    }
                } catch (error) {
                    console.log('setParseExtraInfo-error', error);
                }
            },
            {
                immediate: true,
            }
        );

        return { props, state, defaultErrImage };
    },
});
